module.exports = __webpack_public_path__ + "img/logo-large.4f49e4b2.png";